export const languages = {
  python: {
    id: 1,
    judgeId: 71, // Python 3.8.1
    name: 'Python',
    extension: '.py'
  },
  javascript: {
    id: 2,
    judgeId: 63, // JavaScript Node.js 12.14.0
    name: 'JavaScript',
    extension: '.js'
  },
  cpp: {
    id: 3,
    judgeId: 54, // C++ GCC 9.2.0
    name: 'C++',
    extension: '.cpp'
  },
  java: {
    id: 4,
    judgeId: 62, // Java OpenJDK 13.0.1
    name: 'Java',
    extension: '.java'
  }
} as const;

export type Language = keyof typeof languages;
